import {StyledLink} from './PrimaryNavLink.styles';
import { Link as RouterLink } from 'react-router-dom';

const PrimaryNavLink = ({icon, name, route, isExternal, active}) => {
  return (
    <StyledLink
      component={RouterLink}
      active={active ? 'true' : undefined}
      to={isExternal ? { pathname: route } : route}
      target={isExternal ? '_blank' : undefined}
    >
      {icon}
      {name}
    </StyledLink>
  );
};

export default PrimaryNavLink;
